// GENERATED FILE - DO NOT MODIFY

export enum TimeUnitTypeDto {
    Hour = "Hour",
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}